import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiEndpoints } from '../../constants/api';
import { adminStoreKey } from './admin.const';
import {
  adminReports,
  sharedMetricsInconsistencies,
  apiRecalculateSharedMetrics,
} from '../../constants/api/admin';
import { formatErrorMessage } from '../../utils/error';
import { notificationAlert } from '../notifications/notifications.slice';

export const fetchAdminReports = createAsyncThunk(
  `${adminStoreKey}/${adminReports()}`,
  async (params: { period: number }) => {
    const response = await axios.post(`${apiEndpoints.adminReports()}`, {
      period: params.period,
    });
    return response.data;
  },
);

export const recalculateSharedMetrics = createAsyncThunk(
  `${adminStoreKey}/${apiRecalculateSharedMetrics()}`,
  async (
    params: {
      grossMargin: number;
    },
    thunkAPI,
  ) => {
    try {
      const response = await axios.post(
        `${apiEndpoints.apiRecalculateSharedMetrics()}`,
        {
          grossMargin: params.grossMargin,
        },
      );
      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(
          formatErrorMessage(err, 'Recalculating shared metrics has failed'),
          {
            variant: 'error',
          },
        ),
      );
      throw new Error(String(err));
    }
  },
);

export const fetchSharedMetricsInconsistencies = createAsyncThunk(
  `${adminStoreKey}/${sharedMetricsInconsistencies()}`,
  async () => {
    const response = await axios.post(
      `${apiEndpoints.sharedMetricsInconsistencies()}`,
    );
    return response.data;
  },
);
